import { Component, ElementRef, HostListener, OnInit } from '@angular/core';
import {
  AbstractControl,
  FormArray,
  FormBuilder,
  FormGroup,
  Validators,
} from '@angular/forms';
import { Activity } from 'src/app/model/Avtivity';
import { ActivityType } from 'src/app/model/activityType';
import { ActivityService } from '../../services/activity-services';
import { ActivatedRoute, Router } from '@angular/router';
import { NewParcourCertificate } from 'src/app/model/NewParcourCertificate';
import { PlateformeLMSService } from 'src/app/modules/plateforme-lms/services/plateforme-lms.service';
import { ActivityStatusEnum } from 'src/app/modules/shared/enumeration/activity-status.enum';
import { LOCALISATIONS } from 'src/app/model/localisations';
import { BreadcrumbItem } from 'src/app/modules/shared/components/breadcrumb/breadcrumb.component';
import { Countries } from 'src/app/model/countries';
import { Cities } from 'src/app/model/cities';
import { PersonnelChoisi } from './personnel-forcen/personnel-choisi';
import {
  dateFinApresDebut,
  minLengthArray,
} from 'src/app/modules/shared/validators/sessions.validators';
import { lieuxVersFormulaire } from 'src/app/modules/shared/form/sessions.form';
import { ActivityResponse } from 'src/app/model/dto/ActivityResponse';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-create-activity',
  templateUrl: './create-activity.component.html',
  styleUrls: ['./create-activity.component.css'],
})
export class CreateActivityComponent implements OnInit {
  public activityType: any[] | undefined;
  public activityTypeWithoutResidenceZOne: any[] | undefined;
  public testType: any[] | undefined;
  public testActive: boolean = false;
  activityForm!: FormGroup;

  valid!: boolean;
  error!: boolean;
  inValid!: boolean;

  recupNewParcoursCertif!: NewParcourCertificate[];
  showCetifList: boolean = false;
  showLocalities: boolean = false;
  showCohorts: boolean = false;
  showBootcampLink: boolean = false;
  activityStatus = ActivityStatusEnum;
  localities = LOCALISATIONS.Regions.map((zone) => zone.name);
  //cohorts = Object.values(CohorteEnum);
  cohorts: any[] = [];
  selectedCohorte: string = '';
  showPersonnel: boolean = false;
  listPersonnel: string[] = [];
  personnelChoisi: PersonnelChoisi[] = []; // ← AJOUT : pour l'affichage
  isSubmitting: boolean = false;
  user!: any;
  iuf!: any;
  composante: string = '';
  role!: any;
  showConfirmModal = false;
  tentativeEnvoi = false; // ← AJOUT : vrai après un clic sur Sauvegarder
  private enregistre = false; // ← AJOUT : vrai après une création réussie
  showQuitterModal = false; // ← AJOUT
  toast: { type: 'succes' | 'erreur'; titre: string; message: string } | null =
    null;
  private toastTimer?: ReturnType<typeof setTimeout>;
  // ===== DÉBUT AJOUT : mode modification =====
  idModification: number | null = null;
  chargementActivite = false; // ← AJOUT étape 2
  get modeModification(): boolean {
    return this.idModification !== null;
  }
  // ===== FIN AJOUT =====

  readonly PAYS_ACTIVITES = [
    { flag: 'sn', label: 'Sénégal' },
    { flag: 'bj', label: 'Bénin' },
  ];

  // ===== DÉBUT AJOUT : types d'activité autorisés par pays =====
  // Un pays absent de la liste = tous les types sont autorisés
  readonly TYPES_PAR_PAYS: Record<string, string[]> = {
    bj: ['COMMERCANT_LIVREUR'],
  };
  // ===== FIN AJOUT =====

  // ===== DÉBUT AJOUT : refonte UI =====
  readonly TYPE_ICONES: Record<string, string> = {
    EVENEMENT: 'event',
    WEBINAIRE: 'videocam',
    BOOTCAMP: 'flag',
    MINIJPO: 'groups',
    JPO: 'apartment',
    ATELIER_FORCEN: 'build',
    MASTERCLASS: 'school',
    COMMERCANT_LIVREUR: 'local_shipping',
  };
  // ===== FIN AJOUT =====

  // ===== DÉBUT AJOUT : étape 2 =====
  readonly OPTIONS_AUDIENCE = [
    {
      valeur: ActivityStatusEnum.FOR_ALL_LEARNERS,
      titre: 'Tous les apprenants',
      detail: 'Ouverte à tous',
      icone: 'public',
      bootcampSeulement: false,
    },
    {
      valeur: ActivityStatusEnum.BY_CERTIFICATE_TYPE,
      titre: 'Par certificat',
      detail: 'Une cohorte et ses certificats',
      icone: 'star',
      bootcampSeulement: false,
    },
    {
      valeur: ActivityStatusEnum.BY_RESIDENCE_ZONE,
      titre: 'Par zone de résidence',
      detail: 'Cohortes et zones géographiques',
      icone: 'location_on',
      bootcampSeulement: true,
    },
    {
      valeur: ActivityStatusEnum.TO_DEFINE,
      titre: 'À définir',
      detail: 'Public précisé plus tard',
      icone: 'schedule',
      bootcampSeulement: true,
    },
  ];
  // ===== FIN AJOUT =====
  allCountries: Countries[] = [];
  // ===== DÉBUT AJOUT : sessions =====
  allCities: Cities[] = [];
  villesPays: Cities[] = [];
  // ===== FIN AJOUT =====

  constructor(
    private formBuilder: FormBuilder,
    private activityService: ActivityService,
    private route: Router,
    private plateformeLMSService: PlateformeLMSService,
    private el: ElementRef, // ← AJOUT
    private activatedRoute: ActivatedRoute, // ← AJOUT : mode modification
  ) {
    this.user = sessionStorage.getItem('user');
    this.iuf = JSON.parse(this.user).iuf;
    this.role = JSON.parse(this.user)?.roles[0];
    this.composante = this.getComposante(this.role?.roleName);
  }

  ngOnInit(): void {
    this.activityType = ActivityType.TypesActivity;
    this.activityTypeWithoutResidenceZOne = ActivityType.TypesActivity.filter(
      (item) => item.value !== 'PAR_ZONE_RESIDENCE',
    );

    this.testType = ActivityType.TypesTest;

    this.activityForm = this.formBuilder.group(
      {
        activityName: [null, Validators.required],
        activityType: [null, Validators.required],
        countryFlag: ['sn', Validators.required],
        // ===== DÉBUT AJOUT : sessions =====
        lieux: this.formBuilder.array([]),
        // ===== FIN AJOUT =====
        description: [null, Validators.required],
        beginDate: [null, Validators.required],
        closeDate: [null, Validators.required],
        heure: [null, Validators.required],
        typeTest: [null],
        link: [null, Validators.required],
        adress: [null, Validators.required],
        activitStatus: ['', Validators.required],
        localities: [[]],
        cohort: [null],
        cohorts: [[]],
        bootcampLink: [null],
        certificatIdList: [[]],
      }, // ===== AJOUT : validation des dates =====
      { validators: dateFinApresDebut },
    );

    this.activityForm
      .get('cohort')
      ?.valueChanges.subscribe((selectedCohorte) => {
        // console.log('la cohorte selectionne : ', selectedCohorte);
        this.selectedCohorte = selectedCohorte;
        if (this.selectedCohorte != null && this.selectedCohorte != '') {
          this.getNewCertificate(selectedCohorte);
        }
      });

    this.activityForm.get('activityType')?.valueChanges.subscribe((type) => {
      console.log('Mnagui thi biir ################');
      this.resetVisibility();

      // ✅ 1. nettoyer les données AVANT
      this.resetFieldsForType(type);

      // ✅ 2. nettoyer validators
      this.clearValidators([
        'certificatIdList',
        'localities',
        'cohort',
        'cohorts',
        'bootcampLink',
        'activitStatus',
      ]);

      // ===== DÉBUT AJOUT : sessions =====
      this.lieuxArray.clearValidators();
      if (type !== 'COMMERCANT_LIVREUR') {
        this.lieuxArray.clear();
      }
      this.lieuxArray.updateValueAndValidity();
      // ===== FIN AJOUT =====
      // ===== DÉBUT AJOUT : dates et heure obligatoires par défaut =====
      this.requireValidators(['beginDate', 'closeDate', 'heure']);
      // ===== FIN AJOUT =====

      // ✅ 3. appliquer la nouvelle config
      switch (type) {
        case 'WEBINAIRE':
          this.setValidators('link', [Validators.required]);
          break;

        case 'ATELIER_FORCEN':
          this.showPersonnel = true;
          break;

        case 'BOOTCAMP':
          this.setValidators('activitStatus', [Validators.required]);
          break;

        case 'MINIJPO':
        case 'JPO':
        case 'MASTERCLASS':
          this.clearValidators(['bootcampLink']);
          // rien
          break;

        // ===== DÉBUT AJOUT : sessions =====
        case 'COMMERCANT_LIVREUR':
          this.clearValidators(['bootcampLink']);
          this.lieuxArray.setValidators(minLengthArray(1));
          this.lieuxArray.updateValueAndValidity();
          // ===== DÉBUT AJOUT : dates et heure déduites des sessions =====
          this.clearValidators(['beginDate', 'closeDate', 'heure']);
          this.majPeriodeDepuisSessions('COMMERCANT_LIVREUR');
          // ===== FIN AJOUT =====
          break;
        // ===== FIN AJOUT =====
      }
    });

    this.activityForm.get('activitStatus')?.valueChanges.subscribe((status) => {
      this.resetVisibility();

      // ✅ 1. nettoyer les données AVANT
      this.resetFieldsForStatus(status);

      // ✅ 2. nettoyer validators
      this.clearValidators([
        'certificatIdList',
        'localities',
        'cohort',
        'cohorts',
        'bootcampLink',
      ]);

      // ✅ 3. appliquer la nouvelle config
      switch (status) {
        case ActivityStatusEnum.FOR_ALL_LEARNERS:
          break;

        case ActivityStatusEnum.BY_CERTIFICATE_TYPE:
          this.showCetifList = true;
          this.showCohorts = true;
          this.requireValidators(['certificatIdList', 'cohort']);
          break;

        case ActivityStatusEnum.BY_RESIDENCE_ZONE:
          this.showLocalities = true;
          this.showCohorts = true;
          this.showBootcampLink = true;
          this.requireValidators(['localities', 'bootcampLink', 'cohorts']);
          break;
        case ActivityStatusEnum.TO_DEFINE:
          break;
      }
    });

    this.getAllCohorteParcours();
    this.getCountries();
    // ===== DÉBUT AJOUT : sessions =====
    this.getCities();
    // ===== FIN AJOUT =====
    // ===== DÉBUT AJOUT : la période suit les sessions =====
    this.lieuxArray.valueChanges.subscribe(() =>
      this.majPeriodeDepuisSessions(),
    );
    // ===== FIN AJOUT =====
    // ===== DÉBUT AJOUT : mode modification =====
    // Sur /create-activity il n'y a pas d'id : Number(null) = 0 → mode création
    const id = Number(this.activatedRoute.snapshot.paramMap.get('id'));
    if (id) {
      this.idModification = id;
      this.breadcrumbItems = [
        { label: 'OUTILS' },
        { label: 'ACTIVITES', url: '/dashboard/agenda' },
        { label: "MODIFIER L'ACTIVITE" },
      ];
      this.chargerActivite(id);
    }
    // ===== FIN AJOUT =====
  }

  getNewCertificate(cohorte: string) {
    this.plateformeLMSService
      .getListOfNewParcourcertificateByCohorte(cohorte)
      .pipe()
      .subscribe({
        next: (data: any) => {
          this.recupNewParcoursCertif = data.object;
          // console.log(this.recupNewParcoursCertif);
        },
        error: (err) => {
          alert('Erreur de Recuperation des Données');
        },
      });
  }

  getAllCohorteParcours() {
    this.activityService.getAllCohortesParcours().subscribe((response) => {
      this.cohorts = response.map((r: any) => r.cohorteName);
    });
  }

  getCountries() {
    this.activityService.getCountries().subscribe((pays) => {
      this.allCountries = pays;
    });
  }

  // ===== DÉBUT AJOUT : sessions =====
  getCities() {
    this.activityService.listCity().subscribe((reponse: any) => {
      this.allCities = Array.isArray(reponse)
        ? reponse
        : (reponse?.object ?? []);
      this.majVillesPays();
    });
  }
  // ===== FIN AJOUT =====
  // ===== DÉBUT MODIF : notifications et redirection rapide =====
  onSubmit() {
    if (!this.activityForm.valid) {
      this.activityForm.markAllAsTouched();
      this.afficherToast('erreur', 'Certains champs sont incomplets.');
      return;
    }

    const activity = this.buildActivity(this.activityForm.value);

    if (!activity.countryId) {
      this.afficherToast(
        'erreur',
        "Le pays de l'activité n'a pas pu être chargé. Recharge la page et réessaie.",
      );
      return;
    }

    this.isSubmitting = true;

    // ===== MODIF étape 3 : création ou modification selon le mode =====
    // En modification, le back ignore le public et les participants (V1)
    const enregistrement$: Observable<any> = this.modeModification
      ? this.activityService.modifierActivite(
          activity,
          this.idModification as number,
        )
      : this.activityService.createAvtivity(activity);

    enregistrement$.subscribe({
      next: (reponse) => {
        if (reponse?.status === 200) {
          // isSubmitting reste à true : pas de double envoi pendant la redirection
          this.enregistre = true;
          this.afficherToast('succes', "Retour à l'agenda…");
          setTimeout(() => this.route.navigate(['/dashboard/agenda']), 1500);
        } else {
          this.isSubmitting = false;
          this.afficherToast(
            'erreur',
            this.modeModification
              ? 'Le serveur a refusé la modification.'
              : 'Le serveur a refusé la création.',
          );
        }
      },
      error: (err) => {
        this.isSubmitting = false;
        this.afficherToast('erreur', this.extraireMessageErreur(err));
      },
    });
    // ===== FIN MODIF =====
  }
  // ===== FIN MODIF =====

  // ===== DÉBUT MODIF : Sauvegarder toujours cliquable =====
  openConfirmModal() {
    console.log(
      '[TEST] lieux :',
      this.lieuxArray.length,
      '| validateur :',
      !!this.lieuxArray.validator,
      '| formulaire valide :',
      this.activityForm.valid,
    );
    this.tentativeEnvoi = true;

    if (this.activityForm.valid) {
      this.showConfirmModal = true;
      return;
    }

    this.activityForm.markAllAsTouched();
    // On attend qu'Angular affiche les messages d'erreur avant de défiler
    setTimeout(() => this.allerAuPremierChampInvalide());
  }
  // ===== FIN MODIF =====

  // ===== DÉBUT AJOUT : notifications =====
  afficherToast(
    type: 'succes' | 'erreur',
    message: string,
    titre?: string,
  ): void {
    clearTimeout(this.toastTimer);
    this.toast = {
      type,
      // ===== MODIF : titres selon le mode (création / modification) =====
      titre:
        titre ??
        (type === 'succes'
          ? this.modeModification
            ? 'Activité modifiée avec succès.'
            : 'Activité créée avec succès.'
          : this.modeModification
            ? "Impossible de modifier l'activité."
            : "Impossible de créer l'activité."),
      message,
    };
    const duree = type === 'succes' ? 3000 : 8000;
    this.toastTimer = setTimeout(() => (this.toast = null), duree);
  }

  fermerToast(): void {
    clearTimeout(this.toastTimer);
    this.toast = null;
  }
  // ===== DÉBUT AJOUT : modification, étape 2 : chargement et pré-remplissage =====
  private chargerActivite(id: number): void {
    this.chargementActivite = true;
    this.activityService.getActivityByIdV2(id).subscribe({
      next: (reponse) => {
        this.chargementActivite = false;
        const activite = reponse?.object as ActivityResponse | null;
        if (reponse?.status !== 200 || !activite) {
          this.afficherToast(
            'erreur',
            'Cette activité est introuvable ou a été supprimée.',
          );
          return;
        }
        this.preRemplir(activite);
      },
      error: (err) => {
        this.chargementActivite = false;
        this.afficherToast('erreur', this.extraireMessageErreur(err));
      },
    });
  }

  /**
   * L'ordre compte : le pays filtre les types et les villes, et changer le type
   * remet à zéro une partie du formulaire. Le reste se remplit donc après.
   */
  private preRemplir(a: ActivityResponse): void {
    // 1. Le pays (les anciennes activités sans pays sont au Sénégal)
    this.activityForm
      .get('countryFlag')
      ?.setValue(String(a.countryFlag ?? 'sn').toLowerCase());
    this.majVillesPays();

    // 2. Le type : applique la configuration du formulaire (sections, validateurs)
    this.activityForm.get('activityType')?.setValue(a.activityType);

    // 3. Public et participants verrouillés (V1) : plus obligatoires,
    //    et la sélection du personnel ne s'ouvre pas
    this.clearValidators([
      'activitStatus',
      'certificatIdList',
      'localities',
      'cohort',
      'cohorts',
      'bootcampLink',
    ]);
    this.showPersonnel = false;

    // 4. Les champs modifiables
    this.activityForm.patchValue({
      activityName: a.nomActivity,
      description: a.description,
      beginDate: a.openDate,
      closeDate: a.closeDate,
      heure: a.hours ? String(a.hours).slice(0, 5) : null,
      link: a.accessLink,
      adress: a.adresse,
    });

    // 5. Les sessions de l'Activité informelle, avec leurs ids
    //    (la période se recalcule toute seule à partir des sessions)
    if (String(a.activityType) === 'COMMERCANT_LIVREUR') {
      this.lieuxArray.clear();
      lieuxVersFormulaire(this.formBuilder, a.lieux ?? []).forEach((lieu) =>
        this.lieuxArray.push(lieu),
      );
    }

    // 6. Point de départ : rien n'est encore modifié
    //    (pas de « Quitter sans enregistrer ? » si l'utilisateur ne touche à rien)
    this.activityForm.markAsPristine();
    this.activityForm.markAsUntouched();
  }
  // ===== FIN AJOUT =====
  // ===== DÉBUT MODIF : lecture du message d'erreur du back (format HttpResponse) =====
  private extraireMessageErreur(err: any): string {
    const corps = err?.error;

    // 1. Erreurs de validation (@Valid) : le message précis est dans fieldErrors
    const premierChamp = corps?.fieldErrors?.find((f: any) => f?.message);
    if (premierChamp) {
      return premierChamp.message;
    }

    // 2. Erreurs métier (BusinessException) : le message précis est dans message
    if (corps?.message) {
      return corps.message;
    }

    // 3. Réponse en texte brut
    if (typeof corps === 'string' && corps.trim()) {
      return corps;
    }

    // 4. Serveur injoignable (coupure réseau, VPN…)
    if (err?.status === 0) {
      return 'Impossible de contacter le serveur. Vérifie ta connexion.';
    }

    return 'Une erreur est survenue. Réessaie dans un instant.';
  }
  // ===== FIN MODIF =====

  // ===== DÉBUT AJOUT : défilement vers la première erreur =====
  private allerAuPremierChampInvalide(): void {
    const premier: HTMLElement | null = this.el.nativeElement.querySelector(
      '.fd-error, .is-invalid, .se-error, .se-alert, .se-city.is-invalid, .se-empty',
    );
    if (!premier) {
      return;
    }
    premier.scrollIntoView({ behavior: 'smooth', block: 'center' });

    // Place le curseur dans le champ concerné, s'il y en a un
    const champ = premier.matches('input, select, textarea')
      ? premier
      : premier
          .closest('.fd-field, div')
          ?.querySelector('input, select, textarea');
    (champ as HTMLElement | null)?.focus({ preventScroll: true });
  }

  /** Nombre de champs encore invalides, mis à jour en direct */
  get nbChampsInvalides(): number {
    return this.compterInvalides(this.activityForm);
  }

  private compterInvalides(controle: AbstractControl): number {
    if (controle instanceof FormGroup || controle instanceof FormArray) {
      const enfants = Object.values(controle.controls) as AbstractControl[];
      const erreursPropres = controle.errors ? 1 : 0; // ex. : aucune ville, chevauchement
      return (
        erreursPropres +
        enfants.reduce((t, c) => t + this.compterInvalides(c), 0)
      );
    }
    return controle.invalid ? 1 : 0;
  }
  // ===== FIN AJOUT =====

  cancelSubmit() {
    this.showConfirmModal = false;
  }

  confirmSubmit() {
    this.showConfirmModal = false;
    this.onSubmit();
  }

  markInvalidField(controlName: string) {
    const control = this.activityForm.get(controlName);

    if (control && control.invalid) {
      control.markAsTouched();
    }
  }

  isFieldInvalid(controlName: string): boolean {
    const control = this.activityForm.get(controlName);
    return !!(control && control.invalid && (control.dirty || control.touched));
  }
  // ===== DÉBUT MODIF : confirmation avant de quitter, avec notre propre fenêtre =====
  goToAgenda() {
    if (this.aDesModifications()) {
      this.showQuitterModal = true;
      return;
    }
    this.route.navigate(['/dashboard/agenda']);
  }

  /** « Continuer la saisie » : on ferme la fenêtre, rien n'est perdu */
  resterSurLeFormulaire(): void {
    this.showQuitterModal = false;
  }

  /** « Quitter sans enregistrer » */
  quitterSansEnregistrer(): void {
    this.showQuitterModal = false;
    this.enregistre = true; // évite l'avertissement du navigateur pendant la navigation
    this.route.navigate(['/dashboard/agenda']);
  }

  /** La touche Échap ferme la fenêtre, comme dans toute application */
  @HostListener('document:keydown.escape')
  fermerAvecEchap(): void {
    if (this.showQuitterModal) {
      this.resterSurLeFormulaire();
    }
  }

  // ===== DÉBUT AJOUT : détection des modifications non enregistrées =====
  /** Le formulaire contient-il une saisie non enregistrée ? */
  private aDesModifications(): boolean {
    return (
      !this.enregistre &&
      (this.activityForm.dirty || this.listPersonnel.length > 0)
    );
  }

  /** Rechargement ou fermeture de l'onglet : avertissement du navigateur */
  @HostListener('window:beforeunload', ['$event'])
  avertirAvantFermeture(event: BeforeUnloadEvent): void {
    if (this.aDesModifications()) {
      event.preventDefault();
      event.returnValue = '';
    }
  }
  // ===== FIN AJOUT =====
  // ===== FIN MODIF =====

  // ===== DÉBUT MODIF : choisirPays (sessions) =====
  choisirPays(flag: string): void {
    const actuel = this.activityForm.get('countryFlag')?.value;
    this.activityForm.get('countryFlag')?.markAsDirty(); // ← AJOUT
    if (actuel === flag) {
      return;
    }

    const aDesVilles = this.lieuxArray.controls.some(
      (l) => !!l.get('ville')?.value,
    );
    if (this.isCommercantLivreurSelected() && aDesVilles) {
      const ok = confirm(
        'Changer de pays va réinitialiser les villes des sessions. Continuer ?',
      );
      if (!ok) {
        return;
      }
      this.lieuxArray.controls.forEach((l) => l.get('ville')?.setValue(''));
    }

    this.activityForm.get('countryFlag')?.setValue(flag);
    this.majVillesPays();

    // ===== DÉBUT AJOUT : si le type actuel n'est pas autorisé dans ce pays =====
    const autorises = this.TYPES_PAR_PAYS[flag];
    const typeActuel = this.activityForm.get('activityType')?.value;
    if (autorises && !autorises.includes(typeActuel)) {
      this.choisirType(autorises[0]);
    }
    // ===== FIN AJOUT =====
  }
  // ===== FIN MODIF : choisirPays =====

  // ===== DÉBUT AJOUT : refonte UI =====

  // ===== DÉBUT MODIF : le public est remis à zéro quand le type change =====
  choisirType(valeur: string): void {
    const champ = this.activityForm.get('activityType');
    if (champ?.value === valeur) {
      return;
    }
    champ?.setValue(valeur);
    champ?.markAsTouched();
    champ?.markAsDirty(); // ← AJOUT : compte comme une modification

    const audience = this.activityForm.get('activitStatus');
    audience?.setValue(null);
    audience?.markAsUntouched();
  }
  // ===== FIN MODIF =====

  iconeType(valeur: string): string {
    return this.TYPE_ICONES[valeur] ?? 'event_note';
  }

  get nbCaracteresDescription(): number {
    return this.activityForm.get('description')?.value?.length ?? 0;
  }
  // ===== FIN AJOUT =====

  // ===== DÉBUT AJOUT : libellés pour la modale de confirmation =====
  get libelleType(): string {
    const valeur = this.activityForm.get('activityType')?.value;
    return (
      this.activityTypeWithoutResidenceZOne?.find((t) => t.value === valeur)
        ?.name ?? '—'
    );
  }

  get libelleAudience(): string {
    const valeur = this.activityForm.get('activitStatus')?.value;
    return this.OPTIONS_AUDIENCE.find((o) => o.valeur === valeur)?.titre ?? '';
  }
  // ===== FIN AJOUT =====

  // ===== DÉBUT AJOUT : types proposés selon le pays =====
  get typesDisponibles(): any[] {
    const flag = this.activityForm.get('countryFlag')?.value;
    const autorises = this.TYPES_PAR_PAYS[flag];
    const tous = this.activityTypeWithoutResidenceZOne ?? [];
    return autorises ? tous.filter((t) => autorises.includes(t.value)) : tous;
  }
  // ===== FIN AJOUT =====
  // ===== DÉBUT AJOUT : modification, étape 2b : affichage des verrous =====
  /** En modification : seul le pays de l'activité est affiché */
  get paysAffiches() {
    const actuel = this.activityForm.get('countryFlag')?.value;
    return this.modeModification
      ? this.PAYS_ACTIVITES.filter((p) => p.flag === actuel)
      : this.PAYS_ACTIVITES;
  }

  /** En modification : seul le type de l'activité est affiché */
  get typesAffiches(): any[] {
    if (!this.modeModification) {
      return this.typesDisponibles;
    }
    const actuel = this.activityForm.get('activityType')?.value;
    return (this.activityType ?? []).filter((t) => t.value === actuel);
  }

  /** Types avec un public ou des participants : en modification, un encadré les remplace */
  get publicVerrouille(): boolean {
    const type = this.activityForm.get('activityType')?.value;
    return (
      this.modeModification &&
      ['EVENEMENT', 'WEBINAIRE', 'BOOTCAMP', 'ATELIER_FORCEN'].includes(type)
    );
  }
  // ===== FIN AJOUT =====

  // ===== DÉBUT AJOUT : sessions =====
  /** Villes du pays choisi, sans « Hors Sénégal », triées */
  private majVillesPays(): void {
    const flag = (
      this.activityForm.get('countryFlag')?.value ?? ''
    ).toLowerCase();
    this.villesPays = this.allCities
      .filter((v) => v.codeIso?.toLowerCase() === flag)
      // ===== MODIF : exclut « Hors Sénégal », « Hors Bénin »… =====
      .filter((v) => !v.name?.trim().toLowerCase().startsWith('hors '))
      .sort((a, b) =>
        a.name.localeCompare(b.name, 'fr', { sensitivity: 'base' }),
      );
  }

  /** Résumé affiché dans la modale de confirmation */
  get resumeSessions(): string {
    const lieux = this.lieuxArray.value as any[];
    const nbJours = lieux.reduce((t, l) => t + l.jours.length, 0);
    const nbCreneaux = lieux.reduce(
      (t, l) =>
        t + l.jours.reduce((s: number, j: any) => s + j.creneaux.length, 0),
      0,
    );
    return `${lieux.length} ville(s) · ${nbJours} jour(s) · ${nbCreneaux} créneau(x)`;
  }
  // ===== FIN AJOUT =====

  // ===== DÉBUT AJOUT : période déduite des sessions =====
  /** Première date, dernière date et premier créneau des sessions saisies */
  get periodeSessions(): { debut: string; fin: string; heure: string } | null {
    const sessions: { date: string; debut: string }[] = [];
    for (const lieu of (this.lieuxArray.value ?? []) as any[]) {
      for (const jour of lieu.jours ?? []) {
        for (const c of jour.creneaux ?? []) {
          if (jour.date && c.debut) {
            sessions.push({ date: jour.date, debut: c.debut });
          }
        }
      }
    }
    if (!sessions.length) {
      return null;
    }
    // Les formats "yyyy-MM-dd" et "HH:mm" se trient correctement comme du texte
    sessions.sort((a, b) => (a.date + a.debut).localeCompare(b.date + b.debut));
    return {
      debut: sessions[0].date,
      fin: sessions[sessions.length - 1].date,
      heure: sessions[0].debut,
    };
  }

  /** Recopie la période des sessions dans les champs date et heure */
  private majPeriodeDepuisSessions(type?: string): void {
    const typeActuel = type ?? this.activityForm.get('activityType')?.value;
    if (typeActuel !== 'COMMERCANT_LIVREUR') {
      return;
    }
    const p = this.periodeSessions;
    this.activityForm.patchValue(
      {
        beginDate: p?.debut ?? null,
        closeDate: p?.fin ?? null,
        heure: p?.heure ?? null,
      },
      { emitEvent: false },
    );
  }
  // ===== FIN AJOUT =====

  get nomPaysChoisi(): string {
    const flag = this.activityForm.get('countryFlag')?.value;
    return this.PAYS_ACTIVITES.find((p) => p.flag === flag)?.label ?? '';
  }
  // ===== DÉBUT AJOUT : sessions =====
  get lieuxArray(): FormArray {
    return this.activityForm.get('lieux') as FormArray;
  }
  // ===== FIN AJOUT =====
  isBootcampSelected(): boolean {
    return this.activityForm.value['activityType'] == 'BOOTCAMP';
  }

  isAtelierForceNSelected(): boolean {
    return this.activityForm.value['activityType'] == 'ATELIER_FORCEN';
  }
  isMiniJPOSelected(): boolean {
    return this.activityForm.value['activityType'] == 'MINIJPO';
  }
  isJPOSelected(): boolean {
    return this.activityForm.value['activityType'] == 'JPO';
  }
  isMiniMasterclassSelected(): boolean {
    return this.activityForm.value['activityType'] == 'MASTERCLASS';
  }
  isCommercantLivreurSelected(): boolean {
    return this.activityForm.value['activityType'] == 'COMMERCANT_LIVREUR';
  }

  breadcrumbItems: BreadcrumbItem[] = [
    { label: 'OUTILS' },
    { label: 'ACTIVITES', url: '/dashboard/agenda' },
    { label: 'CREER UNE ACTIVITE', url: '/dashboard/agenda/create-activity' },
  ];

  private getComposante(roleUser: string): string {
    let roles = [
      { id: 1, name: 'admin-fcc', composante: 'FCC' },
      { id: 2, name: 'gestionnaire', composante: 'FCC' },
      { id: 3, name: 'stemd', composante: 'STEMD' },
      { id: 4, name: 'aipen', composante: 'AIPEN' },
      { id: 5, name: 'admin-aipen', composante: 'AIPEN' },
      { id: 6, name: 'admin-finance', composante: 'FINANCE' },
      { id: 7, name: 'finance', composante: 'FINANCE' },
    ];
    const roleFound = roles.find((role) => role.name === roleUser);
    return roleFound ? roleFound?.composante : '';
  }

  // ===== DÉBUT MODIF : on reçoit les personnes complètes =====
  emettreLaliste(data: PersonnelChoisi[]) {
    this.personnelChoisi = data;
    this.listPersonnel = data.map((p) => p.iuf); // inchangé pour le back
  }
  // ===== FIN MODIF =====

  private setValidators(controlName: string, validators: any[] | null) {
    const control = this.activityForm.get(controlName);
    control?.setValidators(validators);
    control?.updateValueAndValidity();
  }

  private clearValidators(controlNames: string[]) {
    controlNames.forEach((name) => this.setValidators(name, null));
  }

  private requireValidators(controlNames: string[]) {
    controlNames.forEach((name) =>
      this.setValidators(name, [Validators.required]),
    );
  }

  private resetVisibility() {
    this.showCohorts = false;
    this.showLocalities = false;
    this.showBootcampLink = false;
    this.showPersonnel = false;
    this.showCetifList = false;
  }

  private resetFieldsForType(type: string) {
    switch (type) {
      case 'WEBINAIRE':
        this.activityForm.patchValue({
          certificatIdList: [],
          localities: [],
          cohort: null,
          bootcampLink: null,
        });
        break;

      case 'ATELIER_FORCEN':
        this.activityForm.patchValue({
          certificatIdList: [],
          localities: [],
          cohort: null,
          bootcampLink: null,
        });
        this.listPersonnel = [];
        break;

      case 'BOOTCAMP':
        // ne reset pas tout (car dépend du status)
        break;

      default:
        this.activityForm.patchValue({
          certificatIdList: [],
          localities: [],
          cohort: null,
          bootcampLink: null,
          activitStatus: null, // ✅ IMPORTANT
        });
    }
  }
  private resetFieldsForStatus(status: ActivityStatusEnum) {
    switch (status) {
      case ActivityStatusEnum.FOR_ALL_LEARNERS:
        this.activityForm.patchValue({
          certificatIdList: [],
          localities: [],
          cohort: null,
          cohorts: [],
          bootcampLink: null,
        });
        break;

      case ActivityStatusEnum.BY_CERTIFICATE_TYPE:
        this.activityForm.patchValue({
          localities: [],
          cohorts: [],
          bootcampLink: null,
        });
        break;

      case ActivityStatusEnum.BY_RESIDENCE_ZONE:
        this.activityForm.patchValue({
          certificatIdList: [],
          cohort: null,
        });
        break;
    }
  }
  private buildActivity(formValue: any): Activity {
    const isForAll =
      formValue.activitStatus === ActivityStatusEnum.FOR_ALL_LEARNERS &&
      formValue.activityType !== 'MINIJPO';

    const certificates =
      formValue.activitStatus === ActivityStatusEnum.BY_CERTIFICATE_TYPE
        ? formValue.certificatIdList
        : [];

    const residenceZones =
      formValue.activitStatus === ActivityStatusEnum.BY_RESIDENCE_ZONE
        ? formValue.localities
        : [];

    /*const cohort = [
      ActivityStatusEnum.BY_RESIDENCE_ZONE,
      ActivityStatusEnum.BY_CERTIFICATE_TYPE,
    ].includes(formValue.activitStatus)
      ? formValue.cohort
      : '';*/

    const cohort =
      formValue.activitStatus === ActivityStatusEnum.BY_CERTIFICATE_TYPE
        ? formValue.cohort
        : '';

    const cohorts =
      formValue.activitStatus === ActivityStatusEnum.BY_RESIDENCE_ZONE
        ? formValue.cohorts
        : [];

    const bootcampLink =
      formValue.activityType === 'BOOTCAMP' ? formValue.bootcampLink : '';

    const listPersonnel =
      formValue.activityType === 'ATELIER_FORCEN' ? this.listPersonnel : [];

    const activity = new Activity(
      formValue.activityName,
      formValue.activityType,
      formValue.description,
      formValue.beginDate,
      formValue.closeDate,
      formValue.adress,
      formValue.typeTest,
      formValue.link,
      formValue.heure,
      isForAll,
      0,
      certificates,
    );

    activity.residenceZones = residenceZones;
    activity.cohort = cohort;
    activity.cohorts = cohorts;
    activity.bootcampLink = bootcampLink;
    activity.listPersonnel = listPersonnel;
    activity.countryId = this.allCountries.find(
      (c) => c.flag?.toLowerCase() === formValue.countryFlag,
    )?.id;
    // ===== DÉBUT AJOUT : sessions =====
    activity.lieux =
      formValue.activityType === 'COMMERCANT_LIVREUR'
        ? formValue.lieux
        : undefined;
    // ===== FIN AJOUT =====

    if (this.composante) {
      activity.composante = this.composante;
    }

    return activity;
  }

  // ===== DÉBUT AJOUT : étape 2 =====
  /** Section « Public concerné » : seulement Événement, Webinaire et Bootcamp */
  get afficherPublic(): boolean {
    // ===== AJOUT : public verrouillé en modification (V1) =====
    if (this.modeModification) {
      return false;
    }
    const type = this.activityForm.get('activityType')?.value;
    return ['EVENEMENT', 'WEBINAIRE', 'BOOTCAMP'].includes(type);
  }

  /** Les options d'audience selon le type (4 pour Bootcamp, 2 sinon) */
  get optionsAudience() {
    return this.OPTIONS_AUDIENCE.filter(
      (o) => !o.bootcampSeulement || this.isBootcampSelected(),
    );
  }

  choisirAudience(valeur: string): void {
    const champ = this.activityForm.get('activitStatus');
    if (champ?.value === valeur) {
      return;
    }
    champ?.setValue(valeur);
    champ?.markAsTouched();
    champ?.markAsDirty(); // ← AJOUT
  }

  estAudience(valeur: string): boolean {
    return this.activityForm.get('activitStatus')?.value === valeur;
  }

  /** Numéros des sections, qui s'adaptent selon ce qui est affiché */
  get num() {
    // ===== MODIF : en modification, l'encadré « Public et participants » occupe la section 2 =====
    const avecSection2 =
      this.afficherPublic ||
      this.isAtelierForceNSelected() ||
      this.publicVerrouille;
    const dates = avecSection2 ? 3 : 2;
    return { dates, acces: dates + 1, sessions: dates + 2 };
  }

  /** Rouvre la sélection du personnel (Atelier Force-N) */
  ouvrirSelectionPersonnel(): void {
    this.showPersonnel = false;
    setTimeout(() => (this.showPersonnel = true));
  }

  // ===== DÉBUT MODIF : retrait par IUF, dans les deux listes =====
  retirerPersonnel(iuf: string): void {
    this.personnelChoisi = this.personnelChoisi.filter((p) => p.iuf !== iuf);
    this.listPersonnel = this.listPersonnel.filter((p) => p !== iuf);
  }
  // ===== FIN MODIF =====
  // ===== FIN AJOUT =====
}
